module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('接送服务')))]), _vm._v(" "), _c('p', {
    staticClass: "price-hint"
  }, [_vm._v(_vm._s(_vm.$T('接送单价说明')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addTakeRow
    }
  }, [_vm._v(_vm._s(_vm.$T('添加接送')))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.takeList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无数据')
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$T('行程类型'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": _vm.$T('请选择行程类型'),
            "clearable": ""
          },
          model: {
            value: (scope.row.direction),
            callback: function($$v) {
              _vm.$set(scope.row, "direction", $$v)
            },
            expression: "scope.row.direction"
          }
        }, [_c('el-option', {
          attrs: {
            "label": _vm.$T('到达'),
            "value": "Arrival"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$T('离港'),
            "value": "Departure"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('出行日期'),
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "date",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (scope.row.date),
            callback: function($$v) {
              _vm.$set(scope.row, "date", $$v)
            },
            expression: "scope.row.date"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('航班车次号'),
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": _vm.$T('请输入航班车次号')
          },
          model: {
            value: (scope.row.transcode),
            callback: function($$v) {
              _vm.$set(scope.row, "transcode", $$v)
            },
            expression: "scope.row.transcode"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('机场站点'),
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": _vm.$T('请选择机场站点'),
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.onStationChange(scope.row)
            }
          },
          model: {
            value: (scope.row.station_id),
            callback: function($$v) {
              _vm.$set(scope.row, "station_id", $$v)
            },
            expression: "scope.row.station_id"
          }
        }, _vm._l((_vm.stationOptions), function(station) {
          return _c('el-option', {
            key: station.id,
            attrs: {
              "label": _vm.stationOptionLabel(station),
              "value": station.id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('人数'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "type": "number",
            "min": "1"
          },
          on: {
            "change": function($event) {
              return _vm.normalizeCount(scope.row, 'member_count')
            }
          },
          model: {
            value: (scope.row.member_count),
            callback: function($$v) {
              _vm.$set(scope.row, "member_count", _vm._n($$v))
            },
            expression: "scope.row.member_count"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('行李件数'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "type": "number",
            "min": "0"
          },
          on: {
            "change": function($event) {
              return _vm.normalizeCount(scope.row, 'luggage_count')
            }
          },
          model: {
            value: (scope.row.luggage_count),
            callback: function($$v) {
              _vm.$set(scope.row, "luggage_count", _vm._n($$v))
            },
            expression: "scope.row.luggage_count"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('状态'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.statusLabel(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('操作'),
      "width": "90",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeTakeRow(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.takePriceItems.length > 0) ? _c('div', {
    staticClass: "price-breakdown"
  }, _vm._l((_vm.takePriceItems), function(item) {
    return _c('div', {
      key: item.station_id,
      staticClass: "price-breakdown__row"
    }, [_c('span', {
      staticClass: "price-breakdown__name"
    }, [_vm._v(_vm._s(item.station_name))]), _vm._v(" "), _c('span', {
      staticClass: "price-breakdown__meta"
    }, [_vm._v("\n          " + _vm._s(_vm.$T('到达合计')) + " " + _vm._s(item.arrival_count) + " · " + _vm._s(_vm.$T('离港合计')) + " " + _vm._s(item.departure_count) + " ·\n          " + _vm._s(_vm.$T('接送计费人数')) + " " + _vm._s(item.billing_count) + " × " + _vm._s(_vm.formatMoney(item.unit_price)) + " USD\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "price-breakdown__line"
    }, [_vm._v(_vm._s(_vm.$T('站点小计')) + ": " + _vm._s(_vm.formatMoney(item.line_total)) + " USD")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.$T('总价')) + ": " + _vm._s(_vm.formatMoney(_vm.takeTransTotal)) + " USD")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onNextStep
    }
  }, [_vm._v(_vm._s(_vm.$T('下一步')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c916be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep5.vue
// module id = 1431
// module chunks = 0